// PaginationList
import React from 'react';
import PropTypes from 'prop-types';

const PaginationList = props => (
  <ul className="pagination pagination-list">
    <li className={`pagination-list-item ${(props.pager.currentPage === 1 ? 'disabled' : '')}`}>
      <button className="pagination-button first-button" onClick={() => props.setPage(1)}><span className="pagination-button-text first-button-text">First</span></button>
    </li>
    <li className={`pagination-list-item ${(props.pager.currentPage === 1 ? 'disabled' : '')}`}>
      <button className="pagination-button previous-button" onClick={() => props.setPage(props.pager.currentPage - 1)}><span className="pagination-button-text previous-button-text">Previous</span></button>
    </li>
    {props.pager.pages.map(page => (
      <li className={`pagination-list-item ${(props.pager.currentPage === page ? 'active' : '')}`}>
        <button className={`pagination-button ${page}-button`} onClick={() => props.setPage(page)}><span className={`pagination-button-text ${page}-button-text`}>{page}</span></button>
      </li>
    ))}
    <li className={`pagination-list-item ${(props.pager.currentPage === props.pager.totalPages ? 'disabled' : '')}`}>
      <button className="pagination-button next-button" onClick={() => props.setPage(props.pager.currentPage + 1)}><span className="pagination-button-text next-button-text">Next</span></button>
    </li>
    <li className={`pagination-list-item ${(props.pager.currentPage === props.pager.totalPages ? 'disabled' : '')}`}>
      <button className="pagination-button last-button" onClick={() => props.setPage(props.pager.totalPages)}><span className="pagination-button-text last-button-text">Last</span></button>
    </li>
  </ul>
);

PaginationList.propTypes = {
  setPage: PropTypes.func.isRequired,
  pager: PropTypes.shape({
    totalItems: PropTypes.number,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    startPage: PropTypes.number,
    endPage: PropTypes.number,
    startIndex: PropTypes.number,
    endIndex: PropTypes.number,
    pages: PropTypes.number,
  }),
};

export default PaginationList;
